import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { ComboBox } from "../../primitives/comboBox";
/**
 * A property line with a filterable ComboBox
 * @param props - ComboBoxProps & PropertyLineProps
 * @returns property-line wrapped ComboBox component
 */
export const ComboBoxPropertyLine = (props) => {
    ComboBoxPropertyLine.displayName = "ComboBoxPropertyLine";
    return (_jsx(PropertyLine, { ...props, children: _jsx(ComboBox, { ...props }) }));
};
//# sourceMappingURL=comboBoxPropertyLine.js.map